import { IActionBase, DriverStartTrip } from '../../models/root.interface';
import * as actionTypes from '../../actions/actionTypes';

import { updateObject } from '../../utility';

const initialState: DriverStartTrip = {
  trip: {},
  loading: null,
  error: null,
  msg: null,
  data: {},
};

// for API Calling
const fetchDriverStartTrip = (state: DriverStartTrip, action: IActionBase) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchDriverStartTripSuccess = (
  state: DriverStartTrip = initialState,
  action: IActionBase
) => {
  return updateObject(state, {
    msg: action.msg,
    loading: false,
    error: null,
    data: action.data,
  });
};

const fetchDriverStartTripFail = (
  state: DriverStartTrip,
  action: IActionBase
) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};
const clearMsgDriverStartTrip = (
  state: DriverStartTrip,
  action: IActionBase
) => {
  return updateObject(state, {
    error: null,
    msg: null,
    loading: null,
  });
};

const driverstarttrip = (
  state: DriverStartTrip = initialState,
  action: IActionBase
) => {
  switch (action.type) {
    case actionTypes.FETCH_DRIVER_START_TRIP:
      return fetchDriverStartTrip(state, action);
    case actionTypes.FETCH_DRIVERTRIP_START_SUCCESS:
      return fetchDriverStartTripSuccess(state, action);
    case actionTypes.FETCH_DRIVERTRIP_START_FAIL:
      return fetchDriverStartTripFail(state, action);
    case actionTypes.CLEAR_MSG_DRIVERSTARTTRIP:
      return clearMsgDriverStartTrip(state, action);
    default:
      return state;
  }
};
export default driverstarttrip;
